import type { JSX } from 'react';
import { WikiTreeNav, type WikiTreeNavProps } from './WikiTreeNav';

export type WikiTreeVariant = 'standard' | 'stripe' | 'minimal';

export function resolveWikiTreeVariant(
  _variant: WikiTreeVariant | undefined,
): (props: WikiTreeNavProps) => JSX.Element | null {
  return WikiTreeNav;
}
